import { MultiStepForm, UserProfileModel } from '@nw/fields-manager';
import { GetProductDetailsResponseType } from '@nw/shared/data-access';

import { BaseProductDetail } from './BaseProductDetail';
import { FlexibleInstallmentPricingDetails } from './FlexibleInstallmentPricingDetails';

export class FlexibleInstallmentProductDetail extends BaseProductDetail {
  readonly installmentType = 'CUSTOMIZABLE';
  readonly initialPricingDetails: FlexibleInstallmentPricingDetails;
  currentPricingDetails: FlexibleInstallmentPricingDetails;

  constructor(
    productDetails: GetProductDetailsResponseType,
    userProfileDetails: UserProfileModel | null = null
  ) {
    super(productDetails);

    this.initialPricingDetails = new FlexibleInstallmentPricingDetails(
      productDetails
    );
    this.currentPricingDetails = this.initialPricingDetails;
    this.form = this.parsedUserExtraInfoConfig
      ? new MultiStepForm(
          this.parsedUserExtraInfoConfig.registration_form_details,
          userProfileDetails,
          this
        )
      : undefined;
  }

  shouldShowCouponApplyButton(): boolean {
    return (
      this.currentPricingDetails.amountToBePaid > 0 &&
      (this.parsedExtraData?.should_show_coupon_apply_button ?? true)
    );
  }

  updateCurrentDetailsWithReferralCodeResponse(
    pricingDetailsObject: FlexibleInstallmentPricingDetails
  ) {
    this.currentPricingDetails = pricingDetailsObject;
  }

  updateCurrentDetailsWithInitialPricingDetails() {
    this.currentPricingDetails = this.initialPricingDetails;
  }

  isValidDownPayment(amount: number): boolean {
    return (
      amount >= this.currentPricingDetails.minimumDownPaymentAmountToBePaid &&
      amount <= this.currentPricingDetails.totalPrincipalAmountToBePaid
    );
  }
}
